module.exports = __webpack_public_path__ + "static/media/jpeg-logo.76885518.svg";